import { Grid, Stack } from "@mui/material";
import PageLayout from "../../components/PageLayout";
import ProfileCard from "./components/ProfileCard";
import AboutMe from "./components/AboutMe";
import WorkExperience from "./components/WorkExperience";
import BlogCard from "../Blog/BlogCard";
import ProjectsSummary from "./components/ProjectsSummary";

export default function Home() {
  return (
    <PageLayout>
      <Grid container spacing={3} alignItems="flex-start">
        <Grid item xs={12} md={4}>
          <Stack spacing={3}>
            <ProfileCard />
            <WorkExperience />
          </Stack>
        </Grid>
        <Grid item xs={12} md={8}>
          <Stack spacing={3}>
            <AboutMe />
            {/* <BlogCard /> */}
            <ProjectsSummary />
          </Stack>
        </Grid>
      </Grid>
    </PageLayout>
  );
}
